import React, { FC, ReactNode } from 'react';
import s from './DurationSnippet.module.scss';

type DurationSnippetProps = {
  children: ReactNode;
};

const DurationSnippet: FC<DurationSnippetProps> = ({
  children,
}) => (
  <div className={s.root}>
    <div className={s.content}>
      {children}
    </div>
  </div>
);
export default DurationSnippet;
